import { render, staticRenderFns } from "./ProjectCart.vue?vue&type=template&id=424b5f84&scoped=true"
import script from "./ProjectCart.vue?vue&type=script&lang=js"
export * from "./ProjectCart.vue?vue&type=script&lang=js"
import style0 from "./ProjectCart.vue?vue&type=style&index=0&id=424b5f84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424b5f84",
  null
  
)

export default component.exports